import React from "react";
import VehicleIcon from "../images/dashboard/vehicle_icon.svg";
import DriverIcon from "../images/dashboard/drivers_icon.svg";
import RouteIcon from "../images/dashboard/routes_icon.svg";
import StopIcon from "../images/dashboard/stops_icon.svg";
import SiteIcon from "../images/dashboard/sites_icon.svg";
import AlertIcon from "../images/dashboard/alerts_icon.svg";
import ActiveIcon from "../images/dashboard/active_vehicle.svg";
import InactiveIcon from "../images/dashboard/inactive_vehicle.svg";
import AlertVehicleIcon from "../images/dashboard/alert_vehicle.svg";
import AlertUserIcon from "../images/dashboard/alert_user.svg";
import AlertDueDateIcon from "../images/dashboard/alert_due.svg";
import StudentIcon from "../images/schoolTracking/cards/student.svg";
import SchoolDriverIcon from "../images/schoolTracking/cards/driver.svg";
import AttendantIcon from "../images/schoolTracking/cards/attendant.svg";
import SchoolVehicleIcon from "../images/schoolTracking/cards/vehicle.svg";
import SchoolStopsIcon from "../images/schoolTracking/cards/stops.svg";
import SchoolRoutesIcon from "../images/schoolTracking/cards/routes.svg";

const ICON_SRC_BY_KEY = {
  "fleet.vehicle": VehicleIcon,
  "fleet.driver": DriverIcon,
  "fleet.route": RouteIcon,
  "fleet.stop": StopIcon,
  "fleet.site": SiteIcon,
  "fleet.alert": AlertIcon,
  "fleet.vehicle.active": ActiveIcon,
  "fleet.vehicle.inactive": InactiveIcon,
  "fleet.alert.vehicle": AlertVehicleIcon,
  "fleet.alert.user": AlertUserIcon,
  "fleet.alert.expiry": AlertDueDateIcon,
  "school.student": StudentIcon,
  "school.driver": SchoolDriverIcon,
  "school.attendant": AttendantIcon,
  "school.vehicle": SchoolVehicleIcon,
  "school.stops": SchoolStopsIcon,
  "school.routes": SchoolRoutesIcon,
};

export function getWidgetIcon(iconKey, alt = "Icon") {
  const src = ICON_SRC_BY_KEY[iconKey];
  if (!src) return null;
  return <img src={src} alt={alt} className="icon" />;
}
